import { axiosInstance } from '../../api';
const BASE_PATH = '/quiz_templates';

//Create Quix Template API Call
export let createQuizTemplate = async (name, specialization, subject_areas, duration, description) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/create_quiz_template', {
            name: name,
            specialization: specialization,
            subject_areas: subject_areas,
            duration: duration,
            description: description
        })
        return value;
    } catch (error) {
        return error
    }
}

//Get Quiz details API call
export let getAllQuizTemplates = async (state) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_quiz_templates', {
            quiz_template_state: state
        })
        return value
    } catch (error) {
        return error
    }
}

//Get Pipeline API Call
export let getQuizTemplate = async (quizTemplateID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_quiz_template', {
            quiz_template_id: quizTemplateID
        })
        return value
    } catch (error) {
        return error
    }
}

export let getQuizDetailsToPiplelineStages = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_quiz_templates_to_add_to_pipeline_step');
        return value
    } catch (error) {
        return error
    }
}

export let addQuestionToQuizTemplate = async (question_values, quiz_templete_id) => {
    try {
        let values = await axiosInstance.post(BASE_PATH + '/add_question_to_quiz_template', {
            quiz_template_id: quiz_templete_id,
            question: question_values.question,
            is_multiple_answer_question: question_values.is_multiple_answer_question,
            answers: question_values.answers
        })
        return values
    } catch (err) {
        return err;
    }
}

export let editQuestionToQuizTemplate = async (question_values, quiz_templete_id, question_id) => {
    try {
        let values = await axiosInstance.post(BASE_PATH + '/edit_question_in_quiz_template', {
            quiz_template_id: quiz_templete_id,
            question_id: question_id,
            question: question_values.question,
            is_multiple_answer_question: question_values.is_multiple_answer_question,
            answers: question_values.answers
        })
        return values
    } catch (err) {
        return err;
    }
}

export let editQuizTemplate = async (name, specialization, subject_areas, duration, description, quiz_template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_quiz_template', {
            quiz_template_id: quiz_template_id,
            name: name,
            specialization: specialization,
            subject_areas: subject_areas,
            duration: duration,
            description: description,

        })
        return value;
    } catch (error) {
        return error
    }
}

export let activateQuizTemplate = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/activate_quiz_template', {
            quiz_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}


export let disableQuizTemplate = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/disable_quiz_template', {
            quiz_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

export let deleteQuestionFromQuiz = async (template_id, ques_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/remove_question_from_quiz_template', {
            quiz_template_id: template_id,
            question_id: ques_id
        })
        return value
    } catch (error) {
        return error
    }
}

export let putBackToDraft = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/put_back_to_draft_mode_quiz_template', {
            quiz_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

export let copyTemplateToNew = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/copy_quiz_template_to_a_new', {
            quiz_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

export let checkIfTemplateEligibleToDisableOrPutBackToDraft = async (template_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/check_quiz_template_eligible_to_make_disable_or_draft', {
            quiz_template_id: template_id,
        })
        return value
    } catch (error) {
        return error
    }
}

export let changeQuestionOrder = async (template_id, questionArray) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/change_quiz_question_order', {
            quiz_template_id: template_id,
            question_array: questionArray,
        })
        return value
    } catch (error) {
        return error
    }
}

